
  import { Component } from 'vue-property-decorator'
  import { PaymentOrder } from '@/entities/finance'
  import Cell from './cell'
  import { plainToInstance } from 'class-transformer'
  import { PurchaseOrder } from '@/entities/purchase'

@Component
  export default class paymentOrderBackup extends Cell {
    declare item: PaymentOrder
    file = null

    async fetchPurchaseFiles () {
      const { item } = this

      const { acquisitionType } = item

      let docTypes = []
      let processRecord
      let tableName

      if (acquisitionType.name === 'consignment') {
        tableName = 'sale_order'
        docTypes = ['invoice_affect', 'exempt_invoice', 'buyer_physical_contract', 'buyer_digital_contract']
        const stockView = (await this.fetchData({
          query: { name: 'find', model: 'StockViewDetails' },
          filter: { id_deal: { _eq: item.deal.id } },
          force: true,
        }))[0]

        if (!stockView?.stock?.id) return

        processRecord = (await this.fetchData({
          query: { name: 'find', model: 'SaleOrder' },
          filter: {
            deal: { id_stock: { _eq: stockView.stock.id } },
            id_document: { _is_null: false },
          },
          force: true,
        }))[0]
      } else {
        tableName = 'purchase_order'
        docTypes = ['invoice_affect', 'exempt_invoice', 'physical_contract', 'digital_contract']
        processRecord = plainToInstance(PurchaseOrder, { id: item.idProcessRecord })
      }

      if (!processRecord?.id) return

      const fileParameters = await this.fetchData({
        query: { name: 'find', model: 'FileParameter' },
        filter: {
          _and: [
            { process: { table_name: { _eq: tableName } } },
            { name: { _in: docTypes } },
          ],
        },
      })

      const fileProcess = (await this.fetchData({
        query: { name: 'find', model: 'FileProcess' },
        filter: {
          _and: [
            { id_file_parameter: { _in: fileParameters.map(item => item.id) } },
            { id_process_record: { _eq: processRecord.id } },
          ],
        },
      }))[0]

      if (fileProcess?.id) {
        this.file = fileProcess.file
      }
    }

    async mounted () {
      const { item } = this
      if (!item.id) return

      if (item.process.tableName === 'purchase_order' && item.idProcessRecord && item.deal?.id) {
        await this.fetchPurchaseFiles()
      } else {
        const fileParameter = (await this.fetchData({
          query: { name: 'find', model: 'FileParameter' },
          filter: {
            _and: [
              { name: { _eq: 'support' } },
              { process: { table_name: { _eq: 'payment_order' } } },
            ],
          },
        }))[0]

        const fileProcess = (await this.fetchData({
          query: { name: 'find', model: 'FileProcess' },
          filter: {
            _and: [
              { id_file_parameter: { _eq: fileParameter.id } },
              { id_process_record: { _eq: item.id } },
            ],
          },
        }))[0]

        if (fileProcess?.id) {
          const { file } = fileProcess

          this.file = file
        }
      }
    }

    downloadDocument () {
      const { file } = this

      if (!file) return

      window.open(file?.uri)
    }

    get disableButton () {
      const { file } = this

      return !file?.id
    }
  }
